const permissions = [
  {
    parent: { value: "manage_dashboard", name: "Manage Dashboard" },
    permissions: [
      { value: "view_total_students", name: "View Total Students" },
      { value: "view_total_staff", name: "View Total Staff" },
      { value: "view_revenue_budget", name: "View Revenue Budget" },
      { value: "view_expense_budget", name: "View Expense Budget" },
      { value: "view_total_revenues", name: "View Total Revenues" },
      { value: "view_total_expenses", name: "View Total Expenses" },
      { value: "view_expected_fees", name: "view Expected Fees" },
      { value: "view_collected_fees", name: "View Collected Fees" },
      { value: "view_student_graph", name: "View Student Graph" },
      { value: "view_fees_graph", name: "view Fees Graph" },
      {
        value: "view_revenue_expenses_graph",
        name: "view Revenue Expenses Graph",
      },
    ],
  },
  {
    parent: { value: "manage_schools", name: "Manage Schools" },
    permissions: [
      { value: "manage_schools", name: "Manage Schools" },
      { value: "view_school", name: "View School" },
      { value: "add_school", name: "Add School" },
      { value: "edit_school", name: "Edit School" },
      { value: "add_license", name: "Add License" },
      { value: "delete_school", name: "Delete School" },
    ],
  },
  {
    parent: { value: "manage_students", name: "Manage Students" },
    permissions: [
      { value: "manage_students", name: "Manage Students" },
      { value: "edit_student", name: "Edit Student" },
      { value: "add_student", name: "Add Student" },
      { value: "cancel_student", name: "Cancel Student" },
      { value: "student_summery", name: "Student Summery" },
      { value: "student_promotion", name: "Student Promotion" },
      { value: "termly_promotion", name: "Termly Promotion" },
      { value: "view_students", name: "View Students" },
    ],
  },
  {
    parent: { value: "manage_exams", name: "Manage Exams" },
    permissions: [
      { value: "manage_exams", name: "Manage Exams" },
      { value: "view_gradings", name: "View Gradings" },
      { value: "add_gradings", name: "Add Gradings" },
      { value: "edit_gradings", name: "Edit Gradings" },
      { value: "delete_gradings", name: "Delete Gradings" },
      { value: "enter_exam_marks", name: "Enter Exam Marks" },
      { value: "view_pass_mark", name: "View Pass Mark" },
      { value: "add_pass_mark", name: "Add Pass Mark" },
      { value: "edit_pass_mark", name: "Edit Pass Mark" },
      { value: "delete_pass_mark", name: "Delete Pass Mark" },
    ],
  },
  {
    parent: { value: "manage_tests", name: "Manage Tests" },
    permissions: [
      { value: "manage_tests", name: "Manage Tests" },
      { value: "view_test_sets", name: "View Test Sets" },
      { value: "add_test_sets", name: "Add Test Sets" },
      { value: "edit_test_sets", name: "Edit Test Sets" },
      { value: "delete_test_sets", name: "Delete Test Sets" },
      { value: "view_considered_tests", name: "View Considered Tests" },
      { value: "add_considered_tests", name: "Add Considered Tests" },
      { value: "delete_considered_tests", name: "Delete Considered Tests" },
      { value: "view_test_contribution", name: "View Test Contribution" },
      { value: "add_test_contribution", name: "Add Test Contribution" },
      { value: "edit_test_contribution", name: "Edit Test Contribution" },
      { value: "delete_test_contribution", name: "Delete Test Contribution" },
      { value: "monthly_assessment", name: "Monthly Assessment" },
      { value: "report_cards", name: "Report Cards" },
      { value: "report_criterias", name: "Report Criterias" },
      { value: "progrssive_report_cards", name: "Progrssive Report Cards" },
      { value: "print_reports", name: "Print Reports" },
      { value: "view_report_comments", name: "View Report Comments" },
      { value: "view_courses", name: "View Courses" },
      { value: "add_course", name: "Add Course" },
      { value: "edit_course", name: "Edit Course" },
      { value: "delete_course", name: "Delete Course" },
      {
        value: "add_report_comments_HM",
        name: "Add Report Comments For Head Teacher",
      },
      {
        value: "add_report_comments_CT",
        name: "Add Report Comments For Class Teacher",
      },
    ],
  },
  {
    parent: { value: "manage_users", name: "Manage Users" },
    permissions: [
      { value: "manage_users", name: "Manage Users" },
      { value: "view_users", name: "View Users" },
      { value: "deactivate_users", name: "Deactivate Users" },
      { value: "add_users", name: "Add Users" },
      { value: "edit_users", name: "Edit Users" },
      { value: "view_roles", name: "View Roles" },
      { value: "add_roles", name: "Add Roles" },
      { value: "deactivate_role", name: "Deactivate Role" },
      { value: "edit_roles", name: "Edit Role" },
      { value: "assign_permissions", name: "Assign Permissions" },
    ],
  },
  {
    parent: { value: "manage_fees", name: "Manage Fees" },
    permissions: [
      { value: "manage_fees", name: "Manage Fees" },
      { value: "pay_fees", name: "Pay Fees" },
      { value: "view_fees_items", name: "View Fees Items" },
      { value: "add_fees_items", name: "Add Fees Items" },
      { value: "edit_fees_items", name: "Edit Fees Items" },
      { value: "delete_fees_items", name: "Delete Fees Items" },
      { value: "view_fees_settings", name: "View Fees Settings" },
      { value: "add_fees_settings", name: "Add Fees Settings" },
      { value: "view_fees_structure", name: "View Fees Structure" },
      { value: "view_fees_payments", name: "View Fees Payments" },
      { value: "make_fees_payments", name: "Make Fees Payments" },
      { value: "edit_fees_payments", name: "Edit Fees Payments" },
      { value: "delete_fees_payments", name: "Delete Fees Payments" },
      { value: "view_previous_balance", name: "View Previous Balance" },
      { value: "view_fees_exemption", name: "View Fees Exemption" },
      { value: "add_fees_exemption", name: "Add Fees Exemption" },
      { value: "edit_fees_exemption", name: "Edit Fees Exemption" },
      { value: "delete_fees_exemption", name: "Delete Fees Exemption" },
      { value: "view_bursary_categories", name: "View Bursary Categories" },
      { value: "add_bursary_categories", name: "Add Bursary Categories" },
      { value: "edit_bursary_categories", name: "Edit Bursary Categories" },
      { value: "delete_bursary_categories", name: "Delete Bursary Categories" },
      { value: "view_bursary", name: "View Bursary" },
      { value: "add_bursary", name: "Add Bursary" },
      { value: "assign_bursary", name: "Assign Bursary" },
      { value: "edit_bursary", name: "Edit Bursary" },
      { value: "delete_bursary", name: "Delete Bursary" },
      { value: "view_fees_addition", name: "View Fees Addition" },
      { value: "add_fees_addition", name: "Add Fees Addition" },
      { value: "edit_fees_addition", name: "Edit Fees Addition" },
      { value: "delete_fees_addition", name: "Delete Fees Addition" },
      { value: "view_fees_receipt", name: "View Fees Receipt" },
      { value: "print_fees_receipt", name: "Print Fees Receipt" },
    ],
  },
  {
    parent: { value: "manage_accounting", name: "Manage Accounting" },
    permissions: [
      { value: "manage_accounting", name: "Manage Accounting" },
      { value: "view_financial_year", name: "View Financial Year" },
      { value: "add_financial_year", name: "Add Financial Year" },
      { value: "edit_financial_year", name: "Edit Financial Year" },
      { value: "delete_financial_year", name: "Delete Financial Year" },
      { value: "view_revenue_categories", name: "View Revenue Categories" },
      { value: "add_revenue_categories", name: "Add Revenue Categories" },
      { value: "edit_revenue_categories", name: "Edit Revenue Categories" },
      { value: "delete_revenue_categories", name: "Delete Revenue Categories" },
      { value: "view_revenue_acc", name: "View Revenue" },
      { value: "add_revenue_acc", name: "Add Revenue" },
      { value: "edit_revenue_acc", name: "Edit Revenue" },
      { value: "delete_revenue_acc", name: "Delete Revenue" },
      { value: "view_revenue_projections", name: "View Revenue Projections" },
      { value: "view_expense_projections", name: "View Expense Projections" },
      { value: "view_expense_categories", name: "View Expense Categories" },
      { value: "add_expense_categories", name: "Add Expense Categories" },
      { value: "edit_expense_categories", name: "Edit Expense Categories" },
      { value: "delete_expense_categories", name: "Delete Expense Categories" },
      { value: "add_expense_item", name: "Add Expense Items" },
      { value: "delete_expense_item", name: "Delete Expense Items" },
      { value: "view_budget", name: "View Budget" },
      { value: "chart_of_accounts", name: "Chart of Accounts" },
      {
        value: "add_account_chart_of_accounts",
        name: "Add Account Chart of Accounts",
      },
      { value: "journal_entries", name: "Journal Entries" },
      { value: "balance_sheet", name: "Balance Sheet" },
      { value: "income_statement", name: "Income Statement" },
      // { value: "account_mapping", name: "Account Mapping" },
    ],
  },
  {
    parent: { value: "manage_expense", name: "Manage Expense" },
    permissions: [
      { value: "manage_expense", name: "Manage Expense" },
      { value: "add_expenses", name: "Add Expenses" },
      { value: "edit_expenses", name: "Edit Expenses" },
      { value: "delete_expenses", name: "Delete Expenses" },
      { value: "view_expenses", name: "View Expenses" },
      { value: "view_creditors", name: "View Creditors" },
      { value: "clear_creditors", name: "Clear Creditors" },
      { value: "add_suppliers", name: "Add Suppliers" },
      { value: "edit_supplier", name: "Edit Supplier" },
      { value: "delete_supplier", name: "Delete Supplier" },
      { value: "view_supplier", name: "View Supplier" },
    ],
  },
  {
    parent: { value: "manage_petty_cash", name: "Manage Petty Cash" },
    permissions: [
      { value: "manage_petty_cash", name: "Manage Petty Cash" },
      { value: "petty_cash", name: "Petty Cash" },
      { value: "approve_petty_cash", name: "Approve Petty Cash" },
      { value: "payments", name: "Payments" },
      { value: "send_custom_sms", name: "Send Custom Sms" },
      { value: "setting_sms", name: "Setting Sms" },
    ],
  },
  {
    parent: { value: "manage_bulk_sms", name: "Manage Bulk SMS" },
    permissions: [
      { value: "manage_bulk_sms", name: "Manage Bulk SMS" },
      { value: "sms_dashboard", name: "SMS Dashboard" },
      { value: "send_fees_sms", name: "Send Fees SMS" },
      { value: "send_marks_sms", name: "Send Marks SMS" },
      { value: "send_custom_sms", name: "Send Custom SMS" },
      { value: "setting_sms", name: "Setting SMS" },
    ],
  },
  {
    parent: {
      value: "manage_advance_staff_settings",
      name: "Manage Advance Staff Settings",
    },
    permissions: [
      {
        value: "manage_advance_staff_settings",
        name: "Manage Advance Staff Settings",
      },
      { value: "add_staff_position", name: "Add Staff Position" },
      { value: "edit_staff_position", name: "Edit Staff Position" },
      { value: "delete_staff_position", name: "Delete Staff Position" },
      { value: "view_staff_position", name: "View Staff Position" },
      { value: "add_staff_member", name: "Add Staff Member" },
      { value: "edit_staff_member", name: "Edit Staff Member" },
      { value: "delete_staff_member", name: "Delete Staff Member" },
      { value: "view_staff_member", name: "View Staff Member" },
      { value: "view_staff_load", name: "View Staff Load" },
      { value: "add_staff_load", name: "Add Staff Load" },
      { value: "delete_staff_load", name: "Delete Staff Load" },
    ],
  },
  {
    parent: {
      value: "manage_advanced_settings",
      name: "Manage Advanced Settings",
    },
    permissions: [
      {
        value: "manage_advanced_settings",
        name: "Manage Advanced Settings",
      },
      { value: "add_payment_method", name: "Add Payment Method" },
      { value: "edit_payment_method", name: "Edit Payment Method" },
      { value: "delete_payment_method", name: "Delete Payment Method" },
      { value: "view_payment_method", name: "View Payment Method" },
      { value: "view_method_statement", name: "view Method Statement" },
      { value: "current_settings", name: "Current Settings" },
      { value: "finance_reports", name: "Finance Reports" },
      { value: "advanced_marks_reports", name: "Advanced Marks Reports" },
    ],
  },
  {
    parent: {
      value: "manage_academic_settings",
      name: "Manage Academic Settings",
    },
    permissions: [
      {
        value: "manage_academic_settings",
        name: "Manage Academic Settings",
      },
      { value: "add_class", name: "Add Level" },
      { value: "view_class", name: "View Levels" },
      { value: "edit_class", name: "Edit Level" },
      { value: "delete_class", name: "Delete Level" },
      // { value: "add_stream", name: "Add Stream" },
      // { value: "view_stream", name: "View Stream" },
      // { value: "edit_stream", name: "Edit Stream" },
      // { value: "delete_stream", name: "Delete Stream" },
      { value: "add_subject", name: "Add Module" },
      { value: "view_subject", name: "View Modules" },
      { value: "edit_subject", name: "Edit Module" },
      { value: "delete_subject", name: "Delete Module" },
    ],
  },
  // {
  //   parent: {
  //     value: "manage_transport",
  //     name: "Manage Transport",
  //   },
  //   permissions: [
  //     {
  //       value: "manage_transport",
  //       name: "Manage Transport",
  //     },
  //     { value: "school_vehicles", name: "School Vehicles" },
  //     { value: "drivers", name: "Drivers" },
  //     { value: "distance_costs", name: "Distance Costs" },
  //     { value: "student_locations", name: "Student Locations" },
  //     { value: "vehicle_requisitions", name: "Vehicle Requisitions" },
  //   ],
  // },
  {
    parent: {
      value: "manage_inventory",
      name: "Manage Inventory",
    },
    permissions: [
      {
        value: "manage_inventory",
        name: "Manage Inventory",
      },
      { value: "store_items", name: "Store Items" },
      { value: "stock_levels", name: "Stock Levels" },
      { value: "new_stock", name: "New Stock" },
      { value: "give_out", name: "Give Out" },
      { value: "store_logs", name: "Store Logs" },
      { value: "stock_movement_report", name: "Stock Movement Report" },
    ],
  },
  // {
  //   parent: {
  //     value: "manage_requirements",
  //     name: "Manage Requirements",
  //   },
  //   permissions: [
  //     {
  //       value: "manage_requirements",
  //       name: "Manage Requirements",
  //     },
  //     { value: "setup_requirements", name: "Setup Requirements" },
  //     { value: "view_requirements", name: "View Requirements" },
  //     { value: "circular_generation", name: "Circular Generation" },
  //   ],
  // },
];

export { permissions };
